import React, { FC, ReactElement } from 'react';
import { useGetUser } from '../hooks/api-hooks';
import { Navigate, useLocation } from 'react-router-dom';

interface ProtectedRouteProps {
  children: ReactElement;
}

const ProtectedRoute: FC<ProtectedRouteProps> = ({ children }) => {
  const user = useGetUser();
  const from = useLocation();

  if (user.isSuccess && user.data?.id && user.data?.email) {
    return children;
  }

  if (user.isFetched && user.isError && !user.data?.userName) {
    return <Navigate to='/sign-in' state={{ from }} />;
  }

  return (
    <div className='fixed inset-0 z-50 flex flex-col items-center justify-center bg-gradient-to-br from-purple-600 to-blue-500 text-white'>
      {/* Added backdrop blur for depth */}
      <div className='relative flex flex-col items-center backdrop-blur-sm p-8 rounded-2xl'>
        <svg
          className='animate-spin h-12 w-12 text-white'
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 24 24'
          // Added aria-label for accessibility
          aria-label='Loading'
        >
          <circle
            className='opacity-20'
            cx='12'
            cy='12'
            r='10'
            stroke='currentColor'
            strokeWidth='4'
          />
          <path
            className='opacity-80'
            fill='currentColor'
            d='M4 12a8 8 0 018-8v-4C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
          />
        </svg>
        <span className='text-sm text-white/80 mt-6 animate-pulse font-medium tracking-wide'>
        Setting things up, one sec...
      </span>
      </div>
    </div>
  );
};

export default ProtectedRoute;